
import { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';
import contractServices from './contractServices';
import Pagination from 'components/Common/newPagination';

export function SearchContract(param: any) {

    let [ContactRows, setContactRows] = useState(0);
    let [searchContract, setsearchContract] = useState("");
    let [ContactListSearch, initContactSearchList] = useState<any>([]);

    const closeDrawer = () => { param.closeSearchContract(); }

    useEffect(() => {
        apicall();
    }, []);

    var paginationPayload = { pageNumber: 1, pageSize: 10, contract: searchContract }

    const apicall = () => {

        contractServices.publishingSplitsTrackContractCount({ contract: searchContract }).then((respond: any) => {
            ContactRows = respond;
            setContactRows(ContactRows)
            if (respond > 0) {
                apicallListing();
            }
        })
    }

    const apicallListing = () => {
        paginationPayload.contract = searchContract
        contractServices.publishingSplitsTrackContractListing(paginationPayload).then((respond: any) => {
            ContactListSearch = respond
            initContactSearchList(ContactListSearch)
        })
    }

    const setContractRefNum = (contractSelect: any) => {
        param.closeSearchContract({ contractSelected: contractSelect });
    }

    const handleOnChangeContractSearch = (paginationParam: any) => {
        paginationPayload.pageNumber = paginationParam.pageNumber
        paginationPayload.pageSize = paginationParam.pageSize
        apicallListing();
    }

    return (
        <div >

            <Drawer open={param.openSearchContract} onClose={closeDrawer} direction='right' className='react-drawer allowHscroll allowVscroll '>

                <div className="ws-7 pull-right box landing">
                    <div className="ws-12">

                        <div className="box-header-main">  <h2>Search Contract Form</h2>  </div>

                        <div className="ws-12 pll ml">
                            <div className="alert alert-info hide" >Try entering a Contact Code to search</div>

                            <div className="ws-12 ">
                                <div className="ws-7">
                                    <div className="form-format">
                                        <label className="control-label ws-12"  >Contract Search</label>
                                        <input type="text" className="ws-12" placeholder="Enter Contract code / Contract display" value={searchContract} onChange={(e: any) => setsearchContract(e.target.value)} />

                                    </div>
                                </div>
                                <div className="ws-5 mtl pt">
                                    <a href="javascript: void(0);" className="icon-btn edit mtll width100 height35" onClick={apicall}>Search</a>
                                    <a href="javascript: void(0);" className="icon-btn edit mtll width150 height35  hide" data-ng-click="newContract(prefillDefaults)">Add new contract</a>
                                </div>
                            </div>
                        </div>

                        <div className="box-content">
                            <h3 className="capitalize mb pull-left ws- ptl"> ({ContactRows}) contract(s) found</h3>

                            <div className="table-responsive n hide"  >
                                <div className="alert alert-info"> No matching for this search criteria  </div>
                            </div>

                            {ContactRows > 0 && <div className="ws-12">
                                <table className="newTable">
                                    <thead>
                                        <tr>
                                            <th>ContractRefNum</th>
                                            <th>Contract Title</th>
                                            <th>Contact Name</th>
                                            <th>Contract Status</th>
                                            <th>Operations</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            ContactListSearch?.map((values: any) => {
                                                return (
                                                    <tr>
                                                        <td>{values?.contractRefNum}</td>
                                                        <td>{values?.contractTitle}</td>
                                                        <td>{values?.kontactName}</td>
                                                        <td>{values?.contractStatus}</td>
                                                        <td><a className="icon-btn info width90 height35" onClick={() => setContractRefNum(values)}>Select</a></td>
                                                    </tr>
                                                )
                                            })
                                        }

                                    </tbody>
                                </table>
                            </div>}

                            <div className="clearfix">
                                {
                                    (() => {
                                        if (ContactRows && ContactRows > 10) {
                                            return <Pagination onPageChange={handleOnChangeContractSearch} totalRow={ContactRows} />
                                        }
                                    })()
                                }
                            </div>

                        </div>
                    </div>

                    <div className="box-footer">
                        <button className="icon-btn delete width100 height35" onClick={closeDrawer}><i className="fa fa-close"></i> Close</button>
                    </div>
                </div>

            </Drawer>
        </div>

    )
}